(function() {
    'use strict';

    var InvioCredenzialiCtrl = function(
        $q,
        $scope,
        $state,
        $stateParams,
        CONSTANTS,
        messaggiFctr,
        invioCredenzialiService,
        $uibModal
    ) {

        this.loading = 0;
        this.datiCliente = {};
        this.datiMito = null;
        this.invioCredenzialiService = invioCredenzialiService;
        this.invioCredenzialiService.reset();

        this.init = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            this.getDatiCliente($stateParams.codiceUtente);
            this.recuperaConfigurazioni();
        };

        this.getDatiCliente = (codiceUtente) => {
            invioCredenzialiService
                .getDatiMito(codiceUtente)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        }
                        this.datiMito = invioCredenzialiService.datiMito = 
                            resp.data.result.utenzaMito;
                        $scope.$broadcast('datiMitoChange', {});
                        this.loading = (this.loading > 0) ? this.loading + 1 : 1;
                        invioCredenzialiService
                            .getDatiCliente(!!this.datiMito.ndg ? this.datiMito.ndg : this.datiMito.idUtente)
                            .then(
                                (response) => {
                                    if (messaggiFctr.processaResponse(response)) {
                                        return;
                                    }
                                    this.datiCliente = response.data.result;
                                },
                                (error) => {
                                    messaggiFctr.processaResponse(error);
                                }
                            )
                            .finally(() => this.loading--);
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => this.loading--);
        };

        this.recuperaConfigurazioni = () => {
            invioCredenzialiService.recuperaConfigurazioni()
                .then(
                    (resp) => {
                        this.invioCredenzialiService.configurazioniBanca = {};
                        resp.data.result.forEach((item) => {
                            this.invioCredenzialiService.configurazioniBanca[item.codice] = {
                                "disabilitato": item.disabilitato,
                                "obbligatorio": item.obbligatorio,
                                "valoreDefault": item.valoreDefault,
                                "visibile": item.visibile
                            }
                        });
                    },
                    (error) => messaggiFctr.processaResponse(error)
                );
        };

        this.cadVisibile = () => {
            return this.invioCredenzialiService.configurazioniBanca && this.invioCredenzialiService.configurazioniBanca['mito.cad']?.visibile || false;
        };

        this.indietro = () => {
            $state.go('gestioneUtenteMito', $stateParams);
        };

        this.apriModaleModifiche = () => {
            $uibModal.open({
                templateUrl: CONSTANTS.BASE_ROOT + 'modals/storicoModificheContatti/storicoModificheContatti.modal.html',
                controller: 'MitomStoricoModificheContattiController',
                controllerAs: 'storicoCtrl',
                size: 'lg'
            });
        };

        this.apriModaleStorico = () => {
            this.invioCredenzialiService.modalita = 'StoricoCredenziali';
            $uibModal.open({
                templateUrl: CONSTANTS.BASE_ROOT + 'modals/storicoDinamico/storicoDinamico.modal.html',
                controller: 'MitomStoricoDinamicoController',
                controllerAs: 'storicoCtrl',
                size: 'lg'
            });
        };

        this.init();
    };

    InvioCredenzialiCtrl.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomInvioCredenzialiService',
        '$uibModal'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-invio-credenziali/invioCredenziali.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var InvioCredenzialiComponent = {
        controller: InvioCredenzialiCtrl,
        controllerAs: 'invioCredenzialiCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitominvioCredenziali', InvioCredenzialiComponent);
})();